import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  public model: any = {};
  public loading: boolean;
  public url: string;
  success: boolean;

  constructor(private router: Router, private http: HttpClient) {
  }

  ngOnInit() {
    this.router.events.subscribe((url: any) => this.url = url.url);
  }

  contact(): void {
    this.loading = true;
    this.http.post('/email', {
      name: this.model.name,
      email: this.model.email,
      phone: this.model.phone,
      text: this.model.text
    }).subscribe();
    setTimeout(() => {
      this.loading = false;
      this.success = true;
    }, 1500);
  }

  /**
   * Go to anchor
   * @param {string} value
   */
  public goToCycle = (value: string) => {
    const url = this.router.url;
    if (url === '/' || url === '/#full-cycle') {
      try {
        document.querySelector('#' + value).scrollIntoView();
        // now account for fixed header
        const scrolledY = window.scrollY;
        const yourHeight = 93;
        if (scrolledY) {
          window.scroll(0, (scrolledY - yourHeight) - 250);
        }
      } catch (e) {
        console.log(e);
      }
    } else {
      this.router.navigate(['/'], {fragment: value});
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/footer/footer.component.ts